



































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { namespace } from 'vuex-class';
import { AcgnTable, AcgnTableButtonGroup } from '@acgn/herm/src/ui';
import { SearchMixin } from '@acgn/herm/src/mixins';
import { AcgnApprovalDetail, AcgnFormTitle } from '@/components';
import { openUrl } from '@/util';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;

const StatisticNorGetter = namespace('desk/statisticNor').Getter;
const CommGetter = namespace('desk/comm').Getter;
const aproStatusMap: any = {
  1: '否',
  2: '是'
};
// import { unitTypes } from '@/constants/type-helper';
@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnTableButtonGroup,
    AcgnApprovalDetail
  },
  mixins: [SearchMixin]
})

/**
 * 审批明细
 */
export default class AcgnApproveDetail extends Vue {

  @Prop({ default: null }) public comicId: number; // 项目id
  @Prop({ default: null }) public userId: number | null; // 员工id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  @StatisticNorAction private getApproveDetail: any;
  @StatisticAction private getApproveAdminDetail: any;

  @StatisticNorGetter private loadings: any; // loading
  @CommGetter private attributeData: any; // 公共类型

  private apiKey: any = {
    1: 'getApproveAdminDetail',
    2: 'getApproveAdminDetail'
  };

  private searchForm: any = { // 头部筛选项
    project_id: null, // 项目ID
    time_slot: null, // 时间【格式：2020年第9周(11.10-11.17)】
    task_group_id: null, // 任务组ID
    origin_uid: null, // 发起审批人ID
    status: null, // 审批状态【1：待提交 2：审批中 3：已拒绝 4：审批通过 5.终止撤销】
    name: null // 环节名称
  };

  private popData: any = {
    visible: false,
    data: {}
  };

  // 审批状态
  private get instanceStatus() {
    if (!this.attributeData.other_type) {
      return [];
    }
    return this.attributeData.other_type[0];
  }

  private isInitSelect = false; // 是否初始化选项
  private links = []; // 环节
  private tasks = []; // 任务组
  private submitGuys = []; // 上传人
  // private unitTypes: any = unitTypes;
  private get unitTypes() {
    return this.attributeData.unit_type;
  }
  private watchItems: string[] = // 头部筛选项目动态监听
    [
      'searchForm.name',
      'searchForm.time_slot',
      'searchForm.task_group_id',
      'searchForm.origin_uid',
      'searchForm.status'
    ];

  private tableConfig: any = {
    columns: [
      {
        label: '提交人',
        prop: 'origin_uname',
        maxWidth: 100
      },
      {
        label: '所属环节',
        width: 100,
        render: (h: any, { row }: any) => (this as any).renderLink(row)
      },
      {
        label: '审批状态',
        prop: 'status',
        render: (h: any, { row }: any) => (this as any).renderStatus(row)
      },
      {
        label: '件数',
        prop: 'cell_number',
        width: 60,
        align: 'center',
        render: (h: any, { row }: any) => (this as any).renderCellNumber(row)
      },
      {
        label: '单价',
        prop: 'price',
        align: 'center',
        width: 60,
      },
      {
        label: '提交审批时间',
        prop: 'create_time',
        minWidth: 100
      },
      {
        label: '完成审批时间',
        prop: 'finish_time',
        minWidth: 100
      },
      {
        label: '截止时间',
        prop: 'over_submit_time',
        minWidth: 100
      },
      {
        label: '逾期提交',
        prop: 'over_submit_status',
        render(h: any, { row }: any) {
          return h('span', aproStatusMap[row.over_submit_status]);
        }
      },
      {
        label: '逾期审批',
        prop: 'over_approve_status',
        render(h: any, { row }: any) {
          return h('span', aproStatusMap[row.over_approve_status]);
        }
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              color: '#73c800',
              text: '查看',
              type: 'edit',
              to: {
                name: 'desk-comicAuthTask',
                params: {
                  id: this.comicId,
                  task_group_id: row.task_group_id,
                  task_id: row.task_id
                }
              },
              disabled: false
            },
            {
              color: '#73c800',
              text: '审批详情',
              type: 'detail',
              disabled: false
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private created() {
    this.searchForm.time_slot = this.$route.params.time;
    (this as any).initSearchWatch(this.watchItems, this.initSearh);
  }

  private renderLink(row: any) {
    return (
      <div style="width:100px" class="text-ellipsis">
        {row.group_name + ' ' + row.task_name + ' ' + row.name}
      </div>
    );
  }

  private renderStatus(row: any, key: string) {
    const status = this.instanceStatus.find((item: any) => item.id === row.status);
    return (
      <span>{status && status.name}</span>
    );
  }
  private renderCellNumber(row: any, key: string) {
    const unitType = this.unitTypes[(row.unit_type || 1) - 1].name;
    return (
      <span>{row.cell_number}{unitType}</span>
    );
  }

  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions(page);
    const { result, paging } = await (this as any)[this.apiKey[this.type]](options);
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page || 1;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;
    this.initSelect(result.options);

    const { size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private initSelect(data: any) {
    if (this.isInitSelect) {
      return;
    }
    this.isInitSelect = true;
    this.tasks = data.task_group.map((item: any) => {
      return {
        id: item.task_group_id,
        name: item.task_group_name
      };
    });
    this.links = data.link.map((item: any) => {
      return {
        id: item,
        name: item
      };
    });
    this.submitGuys = data.origin_user.map((item: any) => {
      return {
        id: item.origin_uid,
        name: item.origin_uname
      };
    });
  }

  // 列表操作项
  private onListAction(item: any) {
    const row = item.row;
    switch (item.type) {
      case 'detail':
        this.popData.data = {
          linkId: row.link_id,
          instanceId: row.instance_id
        };
        this.popData.visible = true;
        break;
    }
  }

  private getSearchOptions(page: number = 1) {
    return {
      page,
      size: 30,
      project_id: this.comicId,
      user_id: this.userId,
      ...filterEmpty(this.searchForm),
    };
  }

  private exportExcel() {
    if (this.type === 1) {
      openUrl('/api/v1/manager/instances?export=1', this.getSearchOptions());
    } else {
      openUrl('/api/v1/manager/instances?export=1', this.getSearchOptions());
    }
  }
}
